import React from "react";
import { formatDate } from "../../../../Utilities/Functions";
import { RecordIcon, ScoreIndicator, LongText } from "../../../../Component";

export const TableHeader = (t) => ([
  {
    title: t("labels.records.table.headers.country"),
    field: "country",
    cellStyle: { width: 100 },
    headerStyle: { width: 100, maxWidth: 200 },
    render: (rowData) => (
      <span style={{ width: 100 }}>
        {rowData.country ? rowData.country : "-"}
      </span>
    ),
  },
  {
    title: t("labels.records.table.headers.recordName"),
    field: "name",
    render: (rowData) => <LongText text={rowData.name} />,
  },
  {
    title: t("labels.records.table.headers.recordType"),
    field: "recordType",
    render: (rowData) => {
      return <RecordIcon entityCategory={rowData.recordType} t={t}/>;
    },
  },
  {
    title: t("labels.records.table.headers.kycScore"),
    field: "kycScore",
    render: (rowData) => {
      return <ScoreIndicator score={rowData.kycScore} expired={rowData.kycExpired}/>;
    },
  },
  {
    title: t("labels.records.table.headers.kycValidity"),
    field: "kycValidTo",
    render: (rowData) => {
      return (
        <span>
          {rowData.kycValidTo === "-" ? "-" : formatDate(rowData.kycValidTo)}
        </span>
      );
    },
  },
  {
    title: t("labels.records.table.headers.amlScore"),
    field: "amlScore",
    render: (rowData) => {
      return <ScoreIndicator score={rowData.amlScore} expired={rowData.amlExpired}/>;
    },
  },
  {
    title: t("labels.records.table.headers.amlValidity"),
    field: "amlValidTo",
    render: (rowData) => {
      return (
        <span>
          {rowData.amlValidTo === "-" ? "-" : formatDate(rowData.amlValidTo)}
        </span>
      );
    },
  },
]);
